import type { FC } from "react";

import { getMcpResourceType } from "../../chat.helpers";
import type { McpResourceLink } from "../../chat.types";
import { DraftArtifactRow } from "./draft-artifact-row";
import { GenericArtifactRow } from "./generic-artifact-row";

export type ArtifactRowComponent = FC<{ resource: McpResourceLink }>;

export const getArtifactRow = (resource: Pick<McpResourceLink, "uri">): ArtifactRowComponent => {
  if (getMcpResourceType(resource.uri) === "draft") {
    return DraftArtifactRow;
  }

  return GenericArtifactRow;
};
